jQuery(document).ready(function($) {

	/* adds support for HTML5 placeholder attribute */
	$('input, textarea').placeholder();

	/* SVG falback to PNG support - requires Mondernizer */
	if (!Modernizr.svg) {
	  $('img[src$=".svg"]').each(function() {
	      //Replaces 'logo.svg' with 'logo.png'.
	      $(this).attr('src', $(this).attr('src').replace('.svg', '.png'));
	  });
	}

	/* slidetoggle */
	$("[data-toggle='slide-toggle']").click(function(e){
		e.preventDefault();

		var target = $(this).attr('href');
		var labelOpen = $(this).attr('data-labelopen');
		var labelClosed = $(this).attr('data-labelclosed');
		var currentLabel = $('span', this);

		//$(this).children('span').text(something.val() == 'string1' ? 'string2' : 'string1');
		currentLabel.text(currentLabel.text() == labelOpen ? labelClosed: labelOpen);

		$(this).toggleClass('active');
		$(target).slideToggle(300);
	});

	/* superfish for nav dropdown*/
	//$('ul.sf-menu').superfish();

	var sf, body;
	var breakpoint = 600;

  body = $('body');
  sf = $('ul.sf-menu');
  if(body.width() >= breakpoint) {
    // enable superfish when the page first loads if we're on desktop
    sf.superfish({
        delay: 400,
        speed: 175,
        speedOut: 175,
        disableHI: true
    });
  }
  $(window).resize(function() {
      if(body.width() >= breakpoint && !sf.hasClass('sf-js-enabled')) {
          // you only want SuperFish to be re-enabled once (sf.hasClass)
          sf.superfish('init');
      } else if(body.width() < breakpoint) {
          // smaller screen, disable SuperFish
          sf.superfish('destroy');
      }
  });

	/* mobile search toggle */
	$('#mobile-search-toggle').click(function(e){
		e.preventDefault();
		$(this).toggleClass('active')
		$('body').toggleClass('mobile-search-active');
		$('#header-search-input').focus();
	});





	/* BOOTSTRAP COMPONENTS ---------------------------------------*/

	/* bs tooltip component */
	$('[data-toggle=tooltip]').tooltip();

	/* bs popover component */
	$('[data-toggle=popover], [data-toggle=popover-html]').on('click', function(e) {e.preventDefault(); return true;});
	$('[data-toggle=popover]').popover();
	$('[data-toggle=popover-html]').popover({
		html: true,
		content: function(){
			var target = $(this).attr('href');
			return $(target).html();
		}
	});






});
